export { CustomerAgeStatus, getCustomerAgeStatus } from './age'
export { getDatalayerPhoneNumber, isCustomerAdult } from './analytics'
export { getCustomer } from './api'
export { default as DateOfBirthModal } from './components/DateOfBirthModal'
export type {
  AllMarketingConsentsValues,
  MarketingConsentsValues
} from './components/MarketingConsentsCheckboxes'
export { default as MarketingConsentsCheckboxes } from './components/MarketingConsentsCheckboxes'
export { default as OnboardCustomerForm } from './components/OnboardCustomerForm'
export { useCustomerData } from './hooks/useCustomerData'
export { default as ProfileDeliveryAddress } from './pages/ProfileDeliveryAddress'
export { default as ProfileDetails } from './pages/ProfileDetails'
export { default as ProfileInvoiceDetails } from './pages/ProfileInvoiceDetails'
export type {
  AccountPort,
  CustomerPorts,
  DeliveryAddressPort,
  InvoiceAddressPort
} from './ports'
export { CustomerPortsProvider } from './ports'
export type { SessionAuthenticated, SessionUnauthenticated } from './session'
export {
  extractCustomerFromClientSession,
  extractSupportSessionExpiryFromClientSession,
  extractTokenFromClientSession,
  extractTokenFromServerSession
} from './session'
export * from './submodules/addresses'
export type { CustomerSession, CustomerTypes } from './types'
